//商品接口相关的函数
import request from "../utils/request"

export let mapbygroupx = (params) => request.get('/dict/content/mapbygroupx', { params })







